import React from "react";
import { RiLinkM } from "react-icons/ri";
import LoadingImage from "../Common/LoadingImage";
import LoadingVideo from "../Common/LoadingVideo";

const AlbumEmbed = ({ userData }) => {
  return (
    <div>
      {userData?.userWidget?.albumEmbed?.map((item, index) => (
        <div className="mb-3 position-relative" key={index}>
          {item?.isLinkEmbed && item?.embedLink && (
            <a
              className="position-absolute top-0 left-0"
              href={item?.embedLink}
              target="_blank"
              style={{ zIndex: 99 }}
            >
              <RiLinkM color="#fff" size={24} />
            </a>
          )}
          {item?.mediaType === "image" ? (
            <LoadingImage
              src={item?.originalMediaLink || item?.lightWeightMediaLink}
              alt="Album preview"
              className="w-100"
              width="100%"
              height="auto"
              skeletonHeight="250px"
            />
          ) : item?.mediaType === "video" ? (
            <LoadingVideo
              src={item?.originalMediaLink || item?.lightWeightMediaLink}
              width="100%"
              height="auto"
              autoPlay
              loop
              muted
              controls={false}
              skeletonHeight="250px"
              playsInline
            />
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default AlbumEmbed;
